import { UploadSimple } from '@liveauctioneers/hammer-ui-core/icons';
import { InlineButton } from '@liveauctioneers/hammer-ui-core/inlineButton';
import { Tooltip } from '@liveauctioneers/hammer-ui-core/tooltip';
import { useCallback } from 'react';
import { useLocation } from 'react-router-dom';

import { SocialShareIcons } from '@/components/SocialShareIcons/SocialShareIcons';
import { useAppDispatch, useAppSelector } from '@/redux/hooks';
import { recordSocialNetworkShare } from '@/redux/modules/analytics';
import { getBaseUrl } from '@/redux/modules/config';
import { useAppFormatMessage } from '@/utils/intl/useAppFormatMessage';
import { buildUrlFromLocation } from '@/utils/urls';

type Props = {
    imageUrl?: string | null;
    title: string;
};

const ARTICLE_SHARE_ANCHOR_ID = 'article-share-button';

export const ArticleShareButton = ({ imageUrl, title }: Props) => {
    const formatMessage = useAppFormatMessage();
    const dispatch = useAppDispatch();
    const location = useLocation();
    const baseUrl = useAppSelector(getBaseUrl);
    const url = buildUrlFromLocation(location, baseUrl) ?? `${baseUrl}${location.pathname}`;

    const trackShare = useCallback(
        (network: string, shareUrl: string) => {
            dispatch(recordSocialNetworkShare(network, shareUrl));
        },
        [dispatch]
    );

    return (
        <div id={ARTICLE_SHARE_ANCHOR_ID}>
            <InlineButton
                data-testid="article-share-button"
                icon={UploadSimple}
                size="sm"
                type="button"
            >
                {formatMessage(['socialIcons', 'shareButton'])}
            </InlineButton>
            <Tooltip
                anchorSelect={`#${ARTICLE_SHARE_ANCHOR_ID}`}
                clickable
                place="bottom"
            >
                <SocialShareIcons
                    imageUrl={imageUrl ?? undefined}
                    onShare={trackShare}
                    title={title}
                    url={url}
                />
            </Tooltip>
        </div>
    );
};
